import { render, staticRenderFns } from "./TaxratesetupNew.vue?vue&type=template&id=33f83c96"
import script from "./TaxratesetupNew.vue?vue&type=script&lang=js"
export * from "./TaxratesetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports